/**
 * @generated SignedSource<<efaac1929b110b44d100762f6df5c75e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleType = "RECORD" | "RESTRICT";
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRulesListItemRuleDeletionConfirmModal$data = {
  readonly id: string;
  readonly ruleType: AutoRecordRuleType;
  readonly " $fragmentType": "AutoRecordRulesListItemRuleDeletionConfirmModal";
};
export type AutoRecordRulesListItemRuleDeletionConfirmModal$key = {
  readonly " $data"?: AutoRecordRulesListItemRuleDeletionConfirmModal$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemRuleDeletionConfirmModal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordRulesListItemRuleDeletionConfirmModal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ruleType",
      "storageKey": null
    }
  ],
  "type": "AutoRecordRule",
  "abstractKey": null
};

(node as any).hash = "3c93a7ac29daa08680996594634b906b";

export default node;
